import React from "react";

const BulletList: React.FC<{ width?: number; height?: number; className?: string }> = ({
  width = 16,
  height = 16,
  className = ""
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M9 6l11 0"></path>
      <path d="M9 12l11 0"></path>
      <path d="M9 18l11 0"></path>
      <path d="M5 6l0 .01"></path>
      <path d="M5 12l0 .01"></path>
      <path d="M5 18l0 .01"></path>
    </svg>
  );
};

export default BulletList;
